import { useState } from 'react';

// import { useServerClient } from '../useServerClient';
// import { useServerParams } from '../useServerParams';

const _allPaymentMethods = [
    {
        id: "cash",
        name: "Cash",
        description: "Cash Notes",
        icon: "cash"
    },
    {
        id: "card",
        name: "Card",
        description: "Bank issued credit card",
        icon: "creditcard",
        types: [
            {
                id: "visa",
                name: "Visa",
                description: "Visa Pay"
            },
            {
                id: "master",
                name: "Master",
                description: "Master Pay"
            },
            {
                id: "amex",
                name: "Amex",
                description: "American Express Pay"
            }
        ]
    },
    {
        id: "e_wallet",
        name: "EWallet",
        description: "Registered ewallet",
        icon: "ewallet",
        types: [
            {
                id: "touchngo",
                name: "Touch N Go",
                description: "Touch N Go"
            },
            {
                id: "grabpay",
                name: "Grab Pay",
                description: "Grab Pay"
            },
            {
                id: "boostpay",
                name: "Boost Pay",
                description: "Boost Pay"
            }
        ]
    }
];

export function usePaymentMethods() {

    // const { makeCall, getError } = useServerClient();
    // const { getListsUrl } = useServerParams();

    const [ isLoading, setIsLoading ] = useState(false)

    // const endpoint = "documents/sales";
    // const endpoint2 = "documents";
    // const endpoint3 = "document/sales";

    const list = (props) => {

        setIsLoading(true);

        try{

            // const url = getListsUrl(endpoint, props);

            // const response = await makeCall({
            //     url,
            //     method: "GET",
            //     payload: {}
            // });

            const response = {
                data: {
                    paymentMethods: _allPaymentMethods
                }
            };

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }
        
    }

    // const get = async ({ id }) => {

    //     setIsLoading(true);

    //     try{

    //         const url = `${endpoint3}/${id}`

    //         const response = await makeCall({
    //             url,
    //             method: "GET",
    //             payload: {}
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // } 
    
    return { 
        isLoading,
        list,
        // get, 
        // create,
        // update, 
        // remove 
    }
    
}